import { get } from 'fetch-mock';
import { initializeApp } from 'firebase/app';
import { GoogleAuthProvider, getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyDqitBDc8zREdaD-NWXyIHoJMzuFp5N7OA",
    authDomain: "ls-haiel-bot.firebaseapp.com",
    projectId: "ls-haiel-bot",
    storageBucket: "ls-haiel-bot.appspot.com",
    messagingSenderId: "186863288566",
    appId: "1:186863288566:web:36e7060b54610e51826cd7",
    measurementId: "G-C99GQQZ370"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);
const db = getFirestore(app);
const googleAuthProvider = new GoogleAuthProvider();

export { auth, db, googleAuthProvider }




// WEBPACK FOOTER //
// ./src/config/firebase.js